import { useState } from 'react';
import { useQuery,useQueryClient } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import { cancelInvitationResponseSchema,membershipResponseSchema,type TeamRow } from '@gioia365/contracts';
import { apiRequest } from '../api/http';
import { contextQuery,teamQuery,useTab } from '../api/queries';
import { Button } from '../design/components/Button';
import { Card } from '../design/components/Card';
import { Dialog } from '../design/components/Dialog';
import { useT } from '../i18n/locale';
import { messageForError } from '../i18n/errors';

// A separate, bounded Team view: it must never read CRM counts, phone or WhatsApp data while billing blocks access.
export function BillingRecoveryTeam() {
 const t=useT(),tab=useTab(),client=useQueryClient(),router=useRouter();
 const team=useQuery(teamQuery(tab));
 const [target,setTarget]=useState<TeamRow|null>(null),[busy,setBusy]=useState(false),[error,setError]=useState<string|null>(null),[done,setDone]=useState<string|null>(null);
 async function confirm() {
  if(!target||busy)return;setBusy(true);setError(null);
  try {
   if(target.kind==='membership')await apiRequest('POST',`/api/memberships/${encodeURIComponent(target.membershipId)}/suspend`,{tab,schema:membershipResponseSchema});
   else await apiRequest('POST',`/api/invitations/${encodeURIComponent(target.invitationId)}/cancel`,{tab,schema:cancelInvitationResponseSchema});
   setDone(target.kind==='membership'?t('team.done.suspended',{name:target.displayName}):t('team.invitationDialog.cancelled',{email:target.email}));setTarget(null);
   await client.invalidateQueries({queryKey:teamQuery(tab).queryKey});
   await client.invalidateQueries({queryKey:contextQuery(tab).queryKey});
   await client.invalidateQueries({queryKey:['billing','organization']});
   await router.invalidate();
  }catch(error){setError(messageForError(t,error));}finally{setBusy(false);}
 }
 return <Card className="g-stack">
  <p>{t('billing.recovery')}</p><a href="/abbonamento">{t('billing.manageTitle')}</a>
  {team.isPending?<p role="status">{t('common.loading')}</p>:team.isError?<><p role="alert">{messageForError(t,team.error)}</p><Button onClick={()=>void team.refetch()}>{t('common.retry')}</Button></>:team.data.map(row=><div className="g-stack" key={row.kind==='membership'?row.membershipId:row.invitationId}>
   <strong>{row.displayName}</strong><span>{row.role.name} · {t(`team.status.${row.status}`)}</span>
   {!row.isProtectedOwner&&(row.kind==='invitation'||row.status==='active')?<Button disabled={busy} onClick={()=>{setError(null);setTarget(row);}}>{t(row.kind==='membership'?'billing.suspendNamed':'billing.cancelNamed',{name:row.displayName})}</Button>:null}
  </div>)}
  {done?<p role="status">{done}</p>:null}
  {target?<Dialog open title={t(target.kind==='membership'?'billing.suspendNamed':'billing.cancelNamed',{name:target.displayName})} onClose={()=>{if(!busy)setTarget(null);}}>
   <p>{t(target.kind==='membership'?'team.confirm.suspendText':'billing.cancelText',{name:target.displayName})}</p>
   {error?<p role="alert">{error}</p>:null}
   <Button disabled={busy} onClick={()=>void confirm()}>{t(target.kind==='membership'?'billing.confirmSuspend':'billing.confirmCancel')}</Button>
  </Dialog>:null}
 </Card>;
}
